export default __webpack_public_path__ + "fffeeb43bdc162b036e1e08e4abaa3cb.png";